/**
 * Construct a recording ID string.
 *
 * @param socialId The Id of the current social
 * @param companyId The id of the current company
 * @returns A recordingId
 */
export const createGroupRecordingId = ({ companyId, socialId }: { socialId: string; companyId: string }): string => {
  return `group_${companyId}/${socialId}_${Date.now()}/recording`;
};
